<app-dialog
  heading="EDITAR CENTRO DE CUSTO"
  description="Campos com * são obrigatórios."
  closeLabel="Fechar edição de centro de custo"
  (closed)="fechar()"
>
  <form class="grid grid-cols-1 md:grid-cols-3 gap-5 mt-5" [formGroup]="formEditCentro" (ngSubmit)="editCentro()">
    <div class="form-group">
      <label for="edit-cost-center-description" class="input-label">Descrição*</label>
      <input id="edit-cost-center-description" type="text" class="form-input" formControlName="description" />
    </div>
    <div class="form-group">
      <label for="edit-cost-center-code" class="input-label">Código*</label>
      <input id="edit-cost-center-code" type="text" class="form-input" formControlName="code" />
    </div>
    <div class="form-group" *ngIf="podeEscolherEmpresa">
      <label for="edit-cost-center-company" class="input-label">Empresa*</label>
      <ng-select
        labelForId="edit-cost-center-company"
        notFoundText="Nenhum item encontrado"
        [items]="opcoesListCompany"
        [searchable]="true"
        formControlName="companyId"
        bindLabel="name"
        bindValue="id"
        appendTo="body"
      >
      </ng-select>
    </div>

    <div class="flex justify-end md:col-span-3">
      <button *isAllowed="[ERoleAdminString.Admin, 'costcenter.update']" type="submit" class="px-6 btn btn--secondary">
        Salvar alterações
      </button>
    </div>
  </form>
</app-dialog>
